import "./App.scss";
import "@fontsource/roboto/300.css";
import "@fontsource/roboto/400.css";
import "@fontsource/roboto/500.css";
import "@fontsource/roboto/700.css";
import AuthWrapper from "./App/Components/AuthWrapper";
import { RouterProvider } from "react-router-dom";
import { Suspense, useEffect } from "react";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { addWatchForBuildVesion } from "./utils/watchForBuild";
import { useDispatch, useSelector } from "react-redux";
import { handleApiRouterInitialize, routerSelector } from "./App/store/routerSlice";
import { Loading } from "@proscore-ai/proscore-ui-library";

const App = () => {
  const dispatch = useDispatch();
  const { router } = useSelector(routerSelector);
  useEffect(() => {
    addWatchForBuildVesion();
  }, []);

  useEffect(() => {
    dispatch(handleApiRouterInitialize());
  }, []);

  return (
    <Suspense fallback={<Loading />}>
      <AuthWrapper>
        <RouterProvider router={router} />
      </AuthWrapper>
      <ToastContainer theme="colored" />
    </Suspense>
  );
};

export default App;
